import Trophee from '@amo/core/assets/images/AMO_Icons/Trophee.svg';
import { Question } from '@amo/core/components/containers';
import {getTranslation} from "../../../utils/index.js";
import {getStepBySlug} from "formulaire-avenant/src/utils/function.js";
import _ from 'lodash';

export const GoToBesoin = (props) => {
    const { nextQuestion, data, source, goTo } = props;
    const onClickNext = () => {
        if((source === 'conseiller' || source === 'courtier' )&& _.get(data, 'clientTelephone') === '0'){
            goTo({ step: getStepBySlug('votre-tarif'), question: 0 })
        } else {
            nextQuestion(300)
        }
    };
    return (
        <Question icon={Trophee} title={getTranslation('antecedents.goToNeed.title')}>
            <div className={'row justify-content-center'}>
                <div className={'col-lg-10 col-md-12'}>
                    <p className={'mt-3 f-18'} dangerouslySetInnerHTML={{__html: getTranslation('antecedents.goToNeed.text')}}/>
                    <p className={'mt-3 f-18'} dangerouslySetInnerHTML={{__html: getTranslation('antecedents.goToNeed.textBis')}}/>
                </div>
            </div>
            <button className={`btn btn-primary btn-arrow mt-4`} onClick={() => onClickNext()}>
                {getTranslation('antecedents.goToNeed.button')}
            </button>
        </Question>
    );
};
